define('widgets/numericKeypad/viewmodel',[
    'knockout',
    'underscore',
    'widgets/inputs/AbstractInputWidget'
], function (ko, _, AbstractInputWidget) {

    function NumericKeypad () {
        AbstractInputWidget.call(this);
    }

    NumericKeypad.prototype = Object.create(AbstractInputWidget.prototype);

    NumericKeypad.prototype.setValue = function (value) {
        this.field.value(value);
    };

    NumericKeypad.prototype.inputsValue = function (keyValue) {
        return function () {
            if (!this.maxLength || this.field.value().length < ko.unwrap(this.maxLength)) {
                this.setValue(this.field.value() + keyValue);
            }
        }.bind(this);
    };

    NumericKeypad.prototype.deleteLast = function () {
        var currentValue = this.field.value();

        this.setValue(currentValue.substring(0, currentValue.length - 1));
    };

    NumericKeypad.prototype.attached = function (view, parent) {
        parent.classList.add('numeric-keypad-container');
    };

    NumericKeypad.prototype.activate = function (settings) {
        AbstractInputWidget.prototype.activate.call(this, settings);
        this.maxLength = settings.maxLength;
    };

    return NumericKeypad;
});

